import { render, staticRenderFns } from "./envelope-recipient-broker.vue?vue&type=template&id=9114b742"
import script from "./envelope-recipient-broker.vue?vue&type=script&lang=js"
export * from "./envelope-recipient-broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports